import { useMemo, useState } from "react";

import { Container } from "components";
import { AdminDashboardScope, DashboardKpiPeriod } from "types";

import { buildDashboardParams } from "../shared/dashboardParams";

import classes from "./AdminDashboard.module.css";
import AgentsSection from "./AgentsSection";
import BankStatusSection from "./BankStatusSection";
import ConversionSection from "./ConversionSection";
import GoogleCalendarSection from "./GoogleCalendarSection";
import MessagesWidgetSection from "./MessagesWidgetSection";
import OperativeSection from "./OperativeSection";
import OverdueAlertSection from "./OverdueAlertSection";
import ProgressSection from "./ProgressSection";
import TodoWidgetSection from "./TodoWidgetSection";

interface AdminDashboardProps {
  scope?: AdminDashboardScope;
}

const AdminDashboard = ({ scope = "admin" }: AdminDashboardProps) => {
  const [period, setPeriod] = useState<DashboardKpiPeriod>("YEARLY");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const dashboardParams = useMemo(
    () => buildDashboardParams(period, dateFrom, dateTo),
    [dateFrom, dateTo, period],
  );

  return (
    <Container>
      <div className={classes.page}>
        <div className={classes.layout}>
          <OperativeSection
            className={classes.operative}
            period={period}
            dateFrom={dateFrom}
            dateTo={dateTo}
            params={dashboardParams}
            onPeriodChange={setPeriod}
            onDateFromChange={setDateFrom}
            onDateToChange={setDateTo}
            scope={scope}
          />

          <aside className={classes.sideColumn}>
            <OverdueAlertSection className={classes.alertCard} scope={scope} />

            <div className={classes.sideWidgets}>
              <TodoWidgetSection />
              <MessagesWidgetSection />
            </div>
          </aside>

          <ConversionSection className={classes.conversion} params={dashboardParams} scope={scope} />

          <ProgressSection className={classes.progress} scope={scope} />

          <BankStatusSection className={classes.banks} scope={scope} />

          <AgentsSection className={classes.agents} scope={scope} />

          <GoogleCalendarSection className={classes.calendar} />
        </div>
      </div>
    </Container>
  );
};

export default AdminDashboard;
